// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";
import type { MountKind } from "@/features/hardware/device-camera-format";

const MOUNT_STYLES: Record<MountKind, string> = {
  standard: "bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-900 dark:text-gray-400 dark:border-gray-800",
  hinge: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  ceiling: "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-950 dark:text-sky-300 dark:border-sky-900",
};

export function MountBadge({ kind, label }: { kind: MountKind; label: string }) {
  return (
    <Badge variant="outline" className={`font-normal ${MOUNT_STYLES[kind]}`}>
      {label}
    </Badge>
  );
}
